import type { RawParams } from "@uirouter/core";

import type { PageId } from "app/@types/userdata";

import type { IRouterState, RouterTrackingId } from "./IRouterState";

export const resolveRouterTrackingId = (
    toState: Pick<IRouterState, "trackingId" | "pageId">,
    toParams: RawParams = {},
): RouterTrackingId | PageId | undefined => {
    const { trackingId, pageId } = toState;

    return typeof trackingId === "function" ? trackingId(toParams) : trackingId ?? pageId;
};
